import { createBrowserRouter } from 'react-router-dom'
import { publicRoutes } from '../routes/publicRoutes'
import { loggedRoutes } from '../routes/loggedRoutes'
import RouterError from '../RouterError'

export default createBrowserRouter([
    publicRoutes,
    loggedRoutes,
    {
        path: '*',
        element: <RouterError />,
    },
])
